module.exports = __webpack_public_path__ + "cc65363a9d3664da5976b314172cfde9.pdf";